// Mirror of `isDoublesDiscipline` in @tournament-suite/league-rules — the viewer
// builds with CRA, which won't compile TS outside src/.
const DOUBLES_DISCIPLINES = ['DOUBLES', 'DOUBLES_M', 'DOUBLES_F', 'DOUBLES_W', 'DOUBLES_MIX', 'MIXED'];

export function isDoublesDiscipline(discipline: string | null | undefined): boolean {
  return discipline != null && DOUBLES_DISCIPLINES.includes(discipline);
}
